<template>
  <div class="friendlink">
    <div class="content">
      <span class="friendtext">友情链接：</span>
      <div class="address">
        <a v-for="(item,index) in $siteConfig.friendLinks"
           :key="index"
           :href="item.href" target="_blank">{{item.title}}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@css/var.scss";
.friendlink {
//   height: 130px;
  // background: #343842;
  // opacity: 0.05;
  background: rgb(#343842, 0.05);
  padding-top: 15px;
  padding-bottom: 15px;

  .content {
    height: 100%;
    line-height: 36px;
  }
  .friendtext {
    float: left;
    font-size: 16px;
    color: #666666;
    margin-right: 22px;
  }
  .address {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    a {
      width:26%;
      display: inline-block;
      font-size: 16px;
      color: #666666;
    }
    a:hover {
      color: $primaryColor;
    }
  }
}
</style>